import { Avatar, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import * as Redux from 'react-redux';
import { generosEnum } from '../../../../../widgets/fields/GenerosField';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';

const InformacionMatriculaComponent = () => {
  const matriculasStore = Redux.useSelector((state) => state.matriculas);

  const activo = matriculasStore.activo;

  return (
    <Paper elevation={4}>
      <Grid container spacing={0}>
        <Grid item md={12} align="center">
          <Avatar
            alt={activo.estudiante.usuario.perfil.pnombre}
            sx={{ width: 150, height: 150, my: 2 }}
            src={getFilesArchivos(activo.estudiante.usuario.perfil.avatar)}
          />
        </Grid>
        <Grid item md={12} align="center">
          <Typography variant="h6">
            {activo.estudiante.usuario.perfil.tipoDni}-
            {activo.estudiante.usuario.perfil.dni}
          </Typography>
        </Grid>
        <Grid item md={12} align="center">
          <Typography variant="h6">
            {activo.estudiante.usuario.perfil.pnombre}
          </Typography>
        </Grid>
        <Grid item md={12} align="center">
          <Typography variant="h6">
            {activo.estudiante.usuario.perfil.papellido}
          </Typography>
        </Grid>
        <Grid item md={12} align="center">
          <Divider textAlign="left" sx={{}}>
            Detalles
          </Divider>
        </Grid>
        <Grid item md={12} sx={{ p: 2 }}>
          <Grid container spacing={0}>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Correo: </strong>
                {activo.estudiante.usuario.correo}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Fecha de nacimiento: </strong>
                {activo.estudiante.usuario.perfil.fechaNacimiento}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Genero: </strong>
                {generosEnum[activo.estudiante.usuario.perfil.genero]}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default InformacionMatriculaComponent;
